import {
  IndentedRowWrapper,
  RadioLabel,
  StyledCaption,
} from 'modules/workflowNodeEditors/EditorBody.styled';
import styled from 'styled-components';
import { OpenNewWindow16 } from 'ui/icons';
import { spacing } from 'ui/theme';
import { pxToRem } from 'utils/convert';

export const StyledIcon = styled(OpenNewWindow16)`
  vertical-align: text-bottom;
`;

export const TimePickersWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: ${spacing.quarter};
`;

export const StyledIndentRowWrapper = styled(IndentedRowWrapper)`
  flex-direction: column;
`;

export const SendSkipRadioLabel = styled(RadioLabel)`
  margin-top: ${pxToRem(2)};
`;

export const SendSkipStyledCaption = styled(StyledCaption)`
  margin-top: ${spacing.base};
`;
